// @flow
import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import i18n from '../../../../i18n/i18n.js';
import assign from 'lodash/assign';
import moment from 'moment';

import RegisterFieldsInput from '../../Inputs/RegisterFieldsInput';
import Button from '../../Inputs/Button';
import { required } from '../../../../utils/validators';
import {
    PURCHASE_HISTORY_FORM,
    SUBSCRIPTIONS_FORM,
} from '../../../../constants/forms';
import { decodeHTMLEntities } from '../../../../utils';

type Props = {
    content: boolean,
    lng: String,
    auth: {
        purchase_history: Object,
        user: {
            created_at: number,
        },
        isLoadingButton: boolean,
    },
    branding: {
        paywall_primary_color: String,
    },
    initialValues: {
        registerFields: Object,
    },
    exportSuccess: boolean,
    active: boolean,
    name: string,
    params: {
        anyTouched: boolean,
        syncErrors: [],
    },
    handleSubmit: Function,
    fetchPurchaseHistory: Function,
    setForm: Function,
    exportData: Function,
    deleteAccount: Function,
};

class AccountForm extends Component<Props> {
    constructor(props) {
        super(props);

        this.state = {
            export: false,
            delete: false,
            name: '',
        };
    }
    showPurchases = () => {
        this.props.setForm(PURCHASE_HISTORY_FORM);
    };

    showSubscriptions = () => {
        this.props.setForm(SUBSCRIPTIONS_FORM);
    };

    toggleHover = name => {
        this.setState({
            [name]: !this.state[name],
            name: name,
        });
    };

    render() {
        const lng = this.props.lng;
        const props = this.props;

        // branding hover
        let color = {};
        if (this.state[this.state.name]) {
            color[this.state.name] = this.props.branding.paywall_primary_color
                ? this.props.branding.paywall_primary_color
                : '#00aae6';
        }

        return (
            <Fragment>
                <header>
                    <div className="headline">
                        <a
                            className="currentpage"
                            href="#"
                            style={{
                                borderBottom:
                                    '2px solid ' +
                                    props.branding.paywall_primary_color,
                            }}
                        >
                            {i18n.t('user_menu_my_account', { lng })}
                        </a>
                    </div>
                    <div className="member">
                        {i18n.t('email', { lng })}:
                        <strong className="date">
                            {this.props.auth.user
                                ? this.props.auth.user.email
                                : '' /* TODO: translate email label */}
                        </strong>
                        <br />
                        {i18n.t('member_since', { lng })}:
                        <strong className="date">
                            {props.auth.user &&
                                moment(props.auth.user.created_at * 1000)
                                    .utc()
                                    .format('Do MMM YYYY')}
                        </strong>
                    </div>
                </header>
                <section id="ipx-maincontent" className="user-accounts account">
                    <div className="formelements sublinks">
                        <a onClick={this.showPurchases}>
                            {i18n.t('purchases', { lng })}
                        </a>
                        <a onClick={this.showSubscriptions}>
                            {i18n.t('subscriptions', { lng })}
                        </a>
                    </div>
                    <div id="userdetails" className="formelements">
                        <strong>{i18n.t('account_details', { lng })}</strong>
                        <form
                            className="formelements"
                            onSubmit={props.handleSubmit}
                        >
                            <RegisterFieldsInput
                                registerFields={
                                    props.initialValues.registerFields
                                }
                                handleFocus={props.handleFocus}
                                active={props.active}
                                name={props.name}
                                primaryColor={
                                    props.branding.paywall_primary_color
                                }
                            />
                            <div className="buttonholder">
                                <Button
                                    text={i18n.t('update', { lng })}
                                    backgroundColor={
                                        props.branding.paywall_buttons_bg_color
                                    }
                                    touched={
                                        props.params && props.params.anyTouched
                                    }
                                    errors={
                                        props.params && props.params.syncErrors
                                            ? true
                                            : false
                                    }
                                    isLoading={props.auth.isLoadingButton}
                                />
                            </div>
                        </form>
                    </div>
                    <div className="buttonholder gdpr-buttons">
                        <button
                            className="gdpr"
                            onClick={e => {
                                e.preventDefault();
                                props.exportData();
                            }}
                            type="button"
                            onMouseOver={e => {
                                e.preventDefault();
                                this.toggleHover('export');
                            }}
                            onMouseOut={e => {
                                e.preventDefault();
                                this.toggleHover('export');
                            }}
                            style={{
                                color: color['export'],
                                transition: 'all 300ms ease-in-out',
                            }}
                        >
                            <i
                                className="ipic_user"
                                style={{
                                    color: color['export'],
                                    transition: 'all 300ms ease-in-out',
                                }}
                            />
                            <span className="buttonlabel" />
                            {i18n.t('export_data', { lng })}
                        </button>
                        <button
                            className="gdpr"
                            onClick={e => {
                                e.preventDefault();
                                props.deleteAccount();
                            }}
                            type="button"
                            onMouseOver={e => {
                                e.preventDefault();
                                this.toggleHover('delete');
                            }}
                            onMouseOut={e => {
                                e.preventDefault();
                                this.toggleHover('delete');
                            }}
                            style={{
                                color: color['delete'],
                                transition: 'all 300ms ease-in-out',
                            }}
                        >
                            <i
                                className="ipic_delete"
                                style={{
                                    color: color['delete'],
                                    transition: 'all 300ms ease-in-out',
                                }}
                            />
                            <span className="buttonlabel" />
                            {i18n.t('delete_account', { lng })}
                        </button>
                    </div>
                </section>
            </Fragment>
        );
    }
}

export const mapStateToProps = (state: Object, ownProps: Object) => {
    let assignObj = {};
    let registerFields =
        state.auth.registerFields &&
        state.auth.registerFields.map((field, index) => {
            const isUndefined =
                ownProps.auth.user.metadata[field.name] === 'undefined' ||
                ownProps.auth.user.metadata[field.name] === undefined;

            assignObj = assign(assignObj, {
                [field.name]: isUndefined
                    ? decodeHTMLEntities(field.default_value) || ''
                    : decodeHTMLEntities(
                          ownProps.auth.user.metadata[field.name]
                      ),
            });

            return {
                default_value:
                    decodeHTMLEntities(field.default_value) === ''
                        ? decodeHTMLEntities(field.placeholder)
                        : decodeHTMLEntities(field.default_value),
                id: field.id,
                name: decodeHTMLEntities(field.name),
                label: decodeHTMLEntities(field.label),
                options: field.options,
                placeholder: decodeHTMLEntities(field.placeholder),
                required: field.required,
                type: field.type,
                originalName: field.name,
                [field.name]: isUndefined
                    ? ''
                    : decodeHTMLEntities(
                          ownProps.auth.user.metadata[field.name]
                      ),
            };
        });

    let initialValues = {
        registerFields,
    };

    if (!state.auth.isSplitUp) {
        assignObj = assign(assignObj, {
            //ownProps.auth.user because ownProps.auth.user is undefined after
            //user logout
            fullname:
                ownProps.auth.user &&
                decodeHTMLEntities(ownProps.auth.user.full_name),
        });
        registerFields =
            registerFields &&
            registerFields.splice(0, 0, {
                id: 1,
                name: 'fullname',
                label: 'Full name',
                placeholder: 'Full name',
                required: true,
                type: 'input',
                originalName: 'fullname',
                fullname: decodeHTMLEntities(ownProps.auth.user.full_name),
            });
    }

    initialValues = assign(initialValues, assignObj);

    return {
        initialValues: initialValues,
    };
};

AccountForm = reduxForm({
    form: 'accountForm',
    enableReinitialize: true,
})(AccountForm);

export default connect(
    mapStateToProps,
    null
)(AccountForm);



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Account/index.js